<template>
  <v-container class="pa-0">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          step="1"
          :complete="step > 1"
        >{{selectedCampaign ? selectedCampaign.name : 'Select campaign'}}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2" :complete="step > 2">Create your posts</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Review</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1" class="pa-1">
          <v-card class="mb-5" elevation="0">
            <v-card-text v-if="campaigns && campaigns.length > 0">
              <v-list rounded>
                <v-subheader>AVAILABLE CAMPAIGNS</v-subheader>
                <v-list-item-group v-model="selectedCampaign" color="primary">
                  <v-list-item v-for="(item, index) of campaigns" v-bind:key="index" :value="item">
                    <v-list-item-content>
                      <v-list-item-title>{{item.name}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text>
              <v-text-field
                class="mt-5"
                label="Campaign Name"
                placeholder="Enter a new campaign"
                outlined
                v-model="selectedCampaign.name"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                :disabled="!selectedCampaign.name"
                small
                @click="step=2"
              >Create Posts</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content :step="2" class="pa-1">
          <v-card elevation="0">
            <p class="deliverables" v-if="selectedCampaign && selectedCampaign.deliverables">
              Your deliverables for this campaign:              
              <!-- <ul>
                <li
                  v-if="selectedCampaign.deliverables.no_of_stories"
                >{{selectedCampaign.deliverables.no_of_stories}} Story(ies)</li>
                <li
                  v-if="selectedCampaign.deliverables.no_of_posts"
                >{{selectedCampaign.deliverables.no_of_posts}} Post(s)</li>
                <li
                  v-if="selectedCampaign.deliverables.no_of_tiktok_posts"
                >{{selectedCampaign.deliverables.no_of_tiktok_posts}} TikTok Post(s)</li>
                <li
                  v-if="selectedCampaign.deliverables.no_of_carousels"
                >{{selectedCampaign.deliverables.no_of_carousels}} Carousel(s)</li>
                <li
                  v-if="selectedCampaign.deliverables.no_of_video"
                >{{selectedCampaign.deliverables.no_of_video}} Video(s)</li>
                <li
                  v-if="selectedCampaign.deliverables.no_of_reels"
                >{{selectedCampaign.deliverables.no_of_reels}} IG Reel(s)</li>
              </ul> -->
              <post-deliverables :deliverables="selectedCampaign.deliverables"/>
            </p>
            <v-row v-for="(post, postIndex) of posts" v-bind:key="postIndex">
              <v-col>
                <v-card rounded elevation="0" outlined>
                  <v-card-title class="pt-1 pb-1">
                    <v-row style="margin-top:1px;margin-bottom:20px">
                      <v-col class="pa-0" align="left" justify="center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-chip class="ma-0" v-on="on" color="#3F3FFF" small text-color="white">
                              <img
                                v-if="getPostTypeMeta(post.type).imgIcon"
                                :src="getPostTypeMeta(post.type).imgIcon"
                                width="15px"
                                height="15px"
                                class="mr-1"
                                style="object-fit:contain;filter:invert(1);"
                                alt=""
                                aria-hidden="true"
                              />
                              <v-icon
                                v-else
                                small
                                left
                                style="color:#ffffff !important;"
                              >{{ getPostTypeMeta(post.type).icon }}</v-icon>
                              {{post.typeName}}
                              <v-icon small right>mdi-chevron-down</v-icon>
                            </v-chip>
                          </template>
                          <v-list>
                            <v-list-item-group>
                              <v-list-item
                                v-for="(item, postTypeIndex) of postType"
                                v-bind:key="postTypeIndex"
                                :value="item.type"
                                @click="postTypeChanged(postIndex, item)"
                              >
                                <v-list-item-icon class="mr-3">
                                  <img
                                    v-if="item.imgIcon"
                                    :src="item.imgIcon"
                                    width="20px"
                                    height="20px"
                                    style="object-fit:contain;"
                                    alt=""
                                    aria-hidden="true"
                                  />
                                  <v-icon
                                    v-else
                                    size="20"
                                    :style="`color: ${item.iconColor} !important;`"
                                  >{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{item.typeName}}</v-list-item-title>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col align="right" justify="center" class="pa-0">
                        <v-btn
                          class="ma-0"
                          small
                          v-on="on"
                          color="red"
                          outlined
                          pill
                          icon
                          @click="deletePost(postIndex)"
                        >
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 ma-0">
                    <!-- <story-form
                      v-if="post.type === 'story'"
                      :post="post"
                      @media-changed="mediaChanged($event,postIndex)"
                    ></story-form> -->
                    <post-form                      
                      :post="post"
                      :influencer="influencerProfile"
                      :campaign="selectedCampaign"
                      @text-changed="textChanged($event,postIndex)"
                      @media-changed="mediaChanged($event,postIndex)"
                      @vdo-link-changed="vdoLinkChanged($event,postIndex)"
                      @remark-changed="remarkChanged($event,postIndex)"
                    ></post-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row style="margin:30px;">
                <v-col align="center">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <!-- <v-btn v-on="on" small rounded outlined color="secondary">IG Story</v-btn> -->
                          <v-btn class="ma-0" v-on="on" color="secondary" outlined pill>
                            Add New Content
                            <v-icon right>mdi-plus</v-icon>
                          </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, postTypeIndex2) of postType"
                        v-bind:key="postTypeIndex2"
                        @click="addPost(item)"
                      >
                        <v-list-item-icon class="mr-3">
                          <img
                            v-if="item.imgIcon"
                            :src="item.imgIcon"
                            width="20px"
                            height="20px"
                            style="object-fit:contain;"
                            alt=""
                            aria-hidden="true"
                          />
                          <v-icon
                            v-else
                            size="20"
                            :style="`color: ${item.iconColor} !important;`"
                          >{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{item.typeName}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="info" @click="step=1">
                <v-icon style="margin-right: 5px;" >mdi-arrow-left-circle</v-icon>
                Back
              </v-btn>
              <v-btn color="secondary" @click="step=3">Review</v-btn>
              <v-spacer></v-spacer>
              <!-- <v-col align="right" justify="center" cols="4" class="pb-5 pt-0">
              </v-col> -->
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <!-- Review -->
        <v-stepper-content :step="3" class="pa-1" style="margin-top:50px;">
          <v-card elevation="0" flat class="max-auto">
            <v-row  style="margin-bottom:50px;">
              <v-col v-for="(post, postIndex) of posts" v-bind:key="postIndex" cols="12" md="3" lg="3" sm="12">
                <v-hover>
                  <!-- new card -->
                  <v-card
                    max-width="344"
                    class="mx-auto"
                    slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"                   
                  >                  
                    <v-list-item>
                      <!-- <v-list-item-avatar color="grey">
                        <img :src="paserImageUrl(currentUser.profilePicture)" alt="avatar" />
                      </v-list-item-avatar> -->
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1 ma-0">
                          {{selectedCampaign.name}}
                        </v-list-item-title>
                        <v-list-item-subtitle class="caption font-italic">
                          <!-- By -->
                          <!-- <a
                            :href="'https://instagram.com/' + post.author.instagramHandle"
                            target="_blank"
                          >@{{post.author.instagramHandle}}</a> -->
                          <!-- {{currentUserFullName}} -->
                          <social-handle
                            :isInstagram="activePlatform === 'instagram'"
                            :isTikTok="activePlatform === 'tiktok'"
                            :isYoutube="activePlatform === 'youtube'"
                            :isXiaohongshu="activePlatform === 'xiaohongshu'"
                            :isLinkedIn="activePlatform === 'linkedin'"
                            :isTwitter="activePlatform === 'twitter'"
                            :instagramHandle="showActivePlatform.handle.replace('@', '')"
                            :tiktokHandle="showActivePlatform.handle.replace('@', '')"
                            :youtubeHandle="showActivePlatform.handle.replace('@', '')"
                            :xiaohongshuHandle="showActivePlatform.handle.replace('@', '')"
                            :linkedinHandle="showActivePlatform.handle.replace('@', '')"
                            :twitterHandle="showActivePlatform.handle.replace('@', '')"
                            :xiaohongshuFullName="showActivePlatform.fullName"
                            v-if="currentUserFullName && showActivePlatform"
                          />
                          <social-handle
                            :isInstagram="activePlatform === 'instagram' || !activePlatform || currentInf.reqIgHandle"
                            :isTikTok="activePlatform === 'tiktok' || currentInf.reqTikTokHandle"
                            :isYoutube="activePlatform === 'youtube' || currentInf.reqYoutubeHandle"
                            :isXiaohongshu="activePlatform === 'xiaohongshu'"
                            :isLinkedIn="activePlatform === 'linkedin'"
                            :isTwitter="activePlatform === 'twitter'"
                            :instagramHandle="currentUser.igHandle || currentInf.reqIgHandle"
                            :tiktokHandle="currentUser.tiktokHandle || currentInf.reqTikTokHandle"
                            :youtubeHandle="currentUser.youtubeHandle || currentInf.reqYoutubeHandle"
                            :xiaohongshuHandle="currentUser.xhsHandle"
                            :linkedinHandle="currentUser.linkedinHandle || (currentInf.linkedin && currentInf.linkedin.linkedinHandle)"
                            :twitterHandle="currentUser.twitterHandle || (currentInf.twitter && currentInf.twitter.twitterHandle)"
                            v-if="currentUserFullName && !showActivePlatform"
                          />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-menu bottom right>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>

                          <!-- <v-list>
                            <v-list-item
                              v-for="(menuItem, i) in menuOptions"
                              :key="i"
                              @click="actionPostBy(menuItem.action, post)"
                            >
                              <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                              <v-list-item-action>
                                <v-icon>{{menuItem.icon}}</v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list> -->
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                    <v-card-text  @click="showDetails(post)" style="padding:0px;">
                        <v-img
                        v-if="!post.media"
                        src="/static/img/upload-post-photo.png"
                        height="194px"                      
                        style="cursor: pointer"
                      ></v-img>
                      <v-img
                        v-if="post.media && post.media.length"
                        :src="post.media[0].preview.thumbnail" 
                        aspect-ratio="1"                                                                   
                        style="cursor: pointer"
                      ></v-img>
                      <!-- <video
                        v-if="post.type === 'vdo'"
                        height="194px"
                        width="100%"                      
                        style="cursor: pointer"
                      >
                        <source :src="media.preview.thumbnail" type="video/mp4" />Your browser does not support the video tag.
                      </video> -->
                    </v-card-text>                    
                    <v-card-text >                                      
                      <div v-if="post.captionText" class="text-truncate">                          
                          <strong>{{post.captionText}}</strong>
                      </div>
                      <div v-if="post.type !== 'post' && post.type !== 'carousel' && post.vdoLink " style="margin-top:10px;">                                                
                        <v-btn
                          class="ma-0"
                          style="margin-top:5px !important;"
                          outlined                                                    
                          color="indigo"
                          target="_blank"
                          :href="post.vdoLink" 
                          small                         
                        >
                          <v-icon left>mdi-link</v-icon>
                          Video Link
                        </v-btn>
                      </div>
                      <div v-if="post.type === 'story' && post.remark && currentUserRole !== 5" class="text-truncate" style="margin-top:20px;">                          
                          <strong>Remark:</strong>
                          {{post.remark}}
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-chip v-on="on" color="#3F3FFF" small text-color="white" style="margin-bottom:5px;margin-left:10px;">
                        <img
                          v-if="getPostTypeMeta(post.type).imgIcon"
                          :src="getPostTypeMeta(post.type).imgIcon"
                          width="15px"
                          height="15px"
                          class="mr-1"
                          style="object-fit:contain;filter:invert(1);"
                          alt=""
                          aria-hidden="true"
                        />
                        <v-icon v-else small left style="color:#ffffff !important;">{{ getPostTypeMeta(post.type).icon }}</v-icon>
                        {{post.typeName}}                            
                      </v-chip>
                    </v-card-actions>
                  </v-card>
                  <!-- new card -->
                </v-hover>
                <!-- <v-card rounded elevation="0" outlined>
                  <v-card-title class="pt-1 pb-1">
                    <v-row style="margin-top:5px;margin-bottom:20px">
                      <v-col class="pa-0" align="left" justify="center">
                        <v-chip class="ma-0" v-on="on" color="#3F3FFF" small text-color="white">
                          {{post.typeName}}
                          <v-icon small right>mdi-instagram</v-icon>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 ma-0">
                    <v-row align="center" justify="center" style="margin:10px;">
                      <v-col
                        v-for="(media, index) of post.media"
                        :key="index"                        
                        cols="4"
                        md="2"
                        lg="2"
                        sm="3"
                      >
                      <v-hover v-slot:default="{ hover }">
                        <v-card flat class="max-auto" @click="viewMedia(media)" :elevation="hover ? 16 : 2">
                          <v-img                                                       
                            class="grey lighten-2"
                            :src="media.preview.thumbnail"
                          ></v-img>
                        </v-card>
                      </v-hover>
                      </v-col>
                    </v-row>                    
                    <v-row v-if="post.type !== 'story'">
                      <v-col cols="12">
                        <div style="margin:30px 0px 20px 10px;font-weight:400;">
                          Caption<br/>
                          <strong>{{post.captionText}}</strong>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="12">
                        <div style="margin:30px 0px 20px 10px;font-weight:400;">{{post.vdolink}}</div>
                      </v-col>
                    </v-row>                    
                  </v-card-text>
                </v-card> -->
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="info" @click="step=2">
                <v-icon small style="margin-right: 5px;" >mdi-arrow-left-circle</v-icon>
                Back
              </v-btn>
              <v-btn color="secondary" @click="validateSubmitPosts">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <!-- Loading dialog -->
    <loading :text="'Please stand by'" :dialog="isLoading"></loading>
    <!-- Image Preview Dialog -->
    <v-dialog
      v-model="imageDialog"  
      width="600"
      @click:outside="modalClickOutSide"    
    >
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <v-spacer></v-spacer>
          <v-icon @click="imageDialog = false">close</v-icon>
        </v-card-title>
        <!-- <v-row class="pb-0 pr-3" cols="12">
          <v-col class="pb-0" xs="12">
            <v-switch
              class="float-right"
              v-model="isCutOff"
              label="Preview Cut-off"
            ></v-switch>
          </v-col>
        </v-row> -->
        <v-card-text class="mt-2">
          <custom-media-v2
            :media="campaignHelper.customPostMediaConfig(previewMedia, {overlay: isCutOff, creatorView: true, postView: true})"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="previewMedia.preview.src" download target="_blank" v-if="previewMedia.preview">
            <v-btn><v-icon float-left>save_alt</v-icon>Download</v-btn>
          </a>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Post Detail View Dialog -->   
    <v-dialog v-model="postDetail" max-width="1000px" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card class="ims-modal-card draft-post-detail-card">
        <v-toolbar dense flat class="ims-modal-header">
          <v-toolbar-title class="font-weight-bold">
            {{selectedCampaign.name}} Campaign
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon aria-label="Close" @click="postDetail = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fluid class="ims-modal-body draft-post-detail-body">
          <v-row cols="12" style="margin:10px;">
            <v-col xs="6">
              <v-row cols="12">
                <v-col xs="1" md="1" lg="1" class="pa-0 pt-2">
                  <!-- <v-avatar size="35" color="grey lighten-4">
                    <img
                      class="elevation-6"
                      v-bind:src="paserImageUrl(currentUser.profilePicture)"
                      alt="avatar"
                    >
                  </v-avatar> -->
                </v-col>
                <v-col xs="6" class="pa-0">
                  &nbsp;{{currentUserFullName}}
                  <social-handle
                    :isInstagram="activePlatform === 'instagram'"
                    :isTikTok="activePlatform === 'tiktok'"
                    :isYoutube="activePlatform === 'youtube'"
                    :isLinkedIn="activePlatform === 'linkedin'"
                    :isTwitter="activePlatform === 'twitter'"
                    :instagramHandle="showActivePlatform.handle.replace('@', '')"
                    :tiktokHandle="showActivePlatform.handle.replace('@', '')"
                    :youtubeHandle="showActivePlatform.handle.replace('@', '')"
                    :linkedinHandle="showActivePlatform.handle.replace('@', '')"
                    :twitterHandle="showActivePlatform.handle.replace('@', '')"
                    v-if="currentUserFullName && showActivePlatform"
                  />
                  <social-handle
                    :isInstagram="activePlatform === 'instagram' || !activePlatform"
                    :isTikTok="activePlatform === 'tiktok'"
                    :isYoutube="activePlatform === 'youtube'"
                    :isLinkedIn="activePlatform === 'linkedin'"
                    :isTwitter="activePlatform === 'twitter'"
                    :instagramHandle="currentUser.igHandle"
                    :tiktokHandle="currentUser.tiktokHandle"
                    :youtubeHandle="currentUser.youtubeHandle"
                    :linkedinHandle="currentUser.linkedinHandle || (currentInf.linkedin && currentInf.linkedin.linkedinHandle)"
                    :twitterHandle="currentUser.twitterHandle || (currentInf.twitter && currentInf.twitter.twitterHandle)"
                    v-if="currentUserFullName && !showActivePlatform"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col xs="6" class="text-right">
              <v-chip
                color="primary"
                v-if="postData"
                small
              >
                <img
                  v-if="getPostTypeMeta(postData.type).imgIcon"
                  :src="getPostTypeMeta(postData.type).imgIcon"
                  width="15px"
                  height="15px"
                  class="mr-1"
                  style="object-fit:contain;filter:invert(1);"
                  alt=""
                  aria-hidden="true"
                />
                <v-icon v-else small left style="color:#ffffff !important;">{{ getPostTypeMeta(postData.type).icon }}</v-icon>
                {{postData.typeName}}
              </v-chip>
            </v-col>
          </v-row>  
          <v-row align="left" justify="left" style="margin:10px;">
            <v-col
              v-for="(media, index) of postData.media"
              :key="index"                        
              cols="12"
              md="4"
              lg="4"
              sm="3"
            >
            <v-hover v-slot:default="{ hover }">
              <v-card flat class="max-auto" @click="viewMedia(media)" :elevation="hover ? 16 : 2" v-if="media.preview.thumbnail">
                <v-img                                                       
                  class="grey lighten-2"
                  :src="media.preview.thumbnail"
                  aspect-ratio="1"
                ></v-img>
              </v-card>
              <v-card flat class="max-auto" v-else>
                <v-img                                                       
                  class="grey lighten-2"
                  :src="media.preview.thumbnail"
                  aspect-ratio="1"
                ></v-img>
              </v-card>
            </v-hover>
            <btn-download :url="media.preview.src" v-if="!media.preview.thumbnail"></btn-download>
            </v-col>
          </v-row>                       
          <v-row v-if="postData.captionText">
            <v-col cols="12">
              <div class="draft-post-detail-copy">
                <strong>Caption</strong><br/>
                {{postData.captionText}}
              </div>
            </v-col>
          </v-row>
          <v-row v-if="postData.type === 'story' || postData.type === 'video' || postData.type === 'reel' || postData.type === 'tiktok'">
            <v-col cols="12">
              <div style="margin-left:12px;">
                <v-btn
                  class="ma-2"
                  outlined                                                    
                  color="indigo"
                  target="_blank"
                  :href="postData.vdoLink"                          
                >
                  <v-icon left>mdi-link</v-icon>
                  Video Link
              </v-btn>
              </div>              
            </v-col>
          </v-row>
          <v-row v-if="postData.type === 'story' && currentUserRole !== influencerRole">
            <v-col cols="12">
              <div class="draft-post-detail-copy">
                <strong>Remark</strong><br/>
                {{postData.remark}}
              </div>              
            </v-col>
          </v-row>                                    
        </v-container>
        <v-card-actions class="ims-modal-actions draft-post-detail-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="postDetail = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <influencer-terms-modal 
      :dialog='showAgreementModal'
      @termsAggrement="submitPosts" />
    <!-- post media preview modal -->
    <post-media-preview-modal
      :selectedCampaign="selectedCampaign"
      :postData="mediaPreviewData"
      v-model="mediaPreviewDialog"
      :value="mediaPreviewDialog"
      @confirmed="termsAgreed"
    />
  </v-container>
</template>
<style scoped>
  .deliverables {
    font-weight: 400;
    margin:20px;
  }
  .deliverables ul{
    font-weight: 600;
  }

  .draft-post-detail-card {
    height: min(90vh, 820px);
  }

  .draft-post-detail-body {
    padding: 16px 24px 24px;
  }

  .draft-post-detail-copy {
    margin: 30px 20px 0;
    font-weight: 400;
    overflow-wrap: anywhere;
    word-break: normal;
    white-space: pre-wrap;
  }

  .draft-post-detail-actions {
    min-height: 56px;
    padding: 8px 16px;
  }

  @media (max-width: 599px) {
    .draft-post-detail-card {
      height: 100vh;
    }

    .draft-post-detail-body {
      padding: 12px;
    }
  }
</style>
<script>
// import moment from 'moment'
import { mapState } from 'vuex';
import StoryForm from '@/components/scoped/post/StoryForm';
import PostForm from '@/components/scoped/post/PostForm';
import VideoForm from '@/components/scoped/post/VideoForm';
import InfluencerTermsModal from './InfluencerTermsModal'
import campaignConfigs from '@/components/views/Campaign/config';
import postAPIs from './postApi';
import Loading from '@/components/core/Loading';
import pairingAPIs from '../Pairing/pairingAPIs';
// import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import config from '@/config';
import btnDownload from '@/components/scoped/custom/BtnDownload.vue';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import PostDeliverables from '../../scoped/post/Deliverables';
import campaignHelper from '../Campaign/campaignHelper';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import PostMediaPreviewModal from './PostMediaPreviewModal.vue';
import postConfig from './postConfig';
/* eslint-disable */
export default {
  components: {
    PostForm,
    StoryForm,
    VideoForm,
    Loading,
    InfluencerTermsModal,
    btnDownload,
    CustomMediaV2,
    PostDeliverables,
    SocialHandle,
    PostMediaPreviewModal
  },
  data() {
    return {
      step: 1,
      campaigns: [],
      selectedCampaign: {
        name: null,
        id: null
      },
      isLoading: false,
      postType: postConfig.postTypes,
      posts: [],
      previewMedia: '',
      mediaType: '',
      imageDialog: false,
      postDetail: false,
      postData: '',
      influencerRole: config.userRoles.INFLUENCER,
      showAgreementModal: false,
      influencerProfile: {},
      currentInf: null,
      campaignHelper,
      isCutOff: false,
      mediaPreviewDialog: false,
      mediaPreviewData: ''
    };
  },
  created() {
    // const status = campaignConfigs.pairingStatus.ACCEPT;
    const status = campaignConfigs.pairingStatus.ACCEPTED;
    // this.initPosts()
    this.fetchInvitedCampaign(this.influencer, status);
    this.getInfluencerData()
  },
  computed: {
    ...mapState(['user', 'activePlatform', 'showActivePlatform']),
    influencer() {
      return this.$store.state.user.influencerID;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    currentUserID() {
      return this.$store.state.user.id
    },
    currentUser() {
      return this.$store.state.user
    },
    currentUserFullName() {
      return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
    }
  },
  methods: {
    initPosts() {
      this.posts = Object.assign([], this.postType)
    },
    getPostTypeMeta(type) {
      return this.postType.find(postType => postType.type === type) || {}
    },
    validateSubmitPosts() {
      const posts = Object.assign([], this.posts);
      if (!this.validatePosts(posts)) {
        this.step = 2
        return false;
      }
      this.mediaPreviewData = this.posts[0]
      this.mediaPreviewDialog = true
    },
    termsAgreed(agree) {
      if (agree) {
        this.showAgreementModal = true
      }
      return
    },
    /**
     * Bulk submit
     */
    async submitPosts(agree) {
      try {
        this.showAgreementModal = false
        if (!agree) {
          return false;
        }
        const posts = Object.assign([], this.posts);
        // Start submitting
        this.isLoading = true;
        let success = 0;
        let fail = 0;
        let fails = []
        for (let i = 0; i < posts.length; i++) {
          const post = posts[i];
          // console.log('🚀 ~ file: CreateDraftPostV2.vue ~ line 300 ~ submitPosts ~ post', post)
          const formData = this.buildFormData(post);
          let resp = await postAPIs.submitPost(formData);
          // console.log('🚀 ~ file: CreateDraftPostV2.vue ~ line 303 ~ submitPosts ~ resp', resp)
          if (resp.success) {
            success++;
          } else {
            fail++;
            fails.push(post)
            console.error(resp.message);
          }
        }
        this.posts = Object.assign([], fails)
        // Finish uploading
        this.isLoading = false;
        if (fail > 0) {
          this.$swal({
            title: 'Post Submitted',
            html:
              '<p><b>' +
              success +
              '</b> Post(s) are successfully submitted</p>' +
              '<p><b>' +
              fail +
              '</b> Posts(s) are fail to submit</p><p>Please re-submit the fail posts</p>',
            type: 'warning'
          });
          this.step = 2;
        } else {
          this.$swal({
            type: 'success',
            title: 'Successfully submitted',
            html: `<div class="text-left subtitle-1">
            <ul>
              <li style='list-style:none'>Your content will remain publicly accessible through your social media account(s) for a minimum of six (6) months, and you do not work with a competitor brand for the next 4 weeks unless otherwise stated.</li>
            </ul>
            </div>`
          }).then(async result => {
            if (result.value) {
              this.$router.push({ path: '/posts/pending-kobe' });
              // Nyein - turn off sending draft submission email from frontend and moved to nodejs backend
              // let campaign = await campaignAPIs.getCampaign(this.selectedCampaign.id)

              // let coUSers = []
              // let coEmails = []
              // let assignedTo = campaign.assignedTo;
              // for (let assigner of assignedTo) {
              //   const user = await userAPIs.getUser(assigner);
              //   if (user) {
              //     if (user.role === config.userRoles.AD_STRATEGIST) {
              //       coUSers.push(user)
              //     }
              //   }
              // }

              // for (let co of coUSers) {
              //   let coName = `${co.firstName} ${co.lastName}`
              //   let mails = {
              //     'email': co.email,
              //     'name': coName
              //   }
              //   coEmails.push(mails)
              // }
              // let emailParams = {
              //   influencerEmail: this.selectedCampaign.influencer_details.contact_details.email,
              //   templateId: config.DRAFT_HAS_BEEN_SUBMITTED_EMAIL_TEMPLATE_ID,
              //   dynamic_template_data: {
              //     submission_date: moment(this.selectedCampaign.submission_date).format('DD/MM/yyyy'),
              //     submitted_date: moment(Date.now()).format('DD/MM/yyyy'),
              //     influencer: this.influencerProfile.handle,
              //     campaignName: this.selectedCampaign.name,
              //     co_name: coEmails[0].name
              //   }
              // }
              // pairingAPIs.sendEmailSubmittedPost(emailParams).then(() => {
              //   this.$router.push({ path: '/posts/pending-kobe' });
              // })
            }
          });
        }
      } catch (error) {
        this.isLoading = false;
        this.$swal({ type: 'error', text: 'Unexpected error' });
      }
    },
    reset() {
      // reset campaign
      this.selectedCampaign = null;
      // reset posts
      this.posts = [];
      // reset step to select campaign step
      this.step = 1;
    },
    buildFormData(postData) {
      let formData = new FormData();
      let post = Object.assign({}, postData);
      post.campaignID = this.selectedCampaign.id;
      post.clientID = this.selectedCampaign.clientID;
      post.campaignName = this.selectedCampaign.name;
      post.submissionDate = this.selectedCampaign.submission_date;
      post.handle = this.influencerProfile.handle;
      post.platform = this.influencerProfile.platform || this.activePlatform;
      post.profilePicture = this.currentUser.profilePicture
      // const medias = post.media ? post.media.map(m =>
      //   Object.assign({}, {
      //     // publicID: m.publicID,
      //     url: m.file,
      //     type: m.type
      //   })
      // ) : [];
      const medias = post.media ? post.media.map(m => m.file) : [];
      delete post.media;
      formData.append('post', JSON.stringify(post));
      for (const media of medias) {
        formData.append('images', media);
      }
      return formData;
    },
    validatePosts(posts) {
      for (let post of posts) {
        /**
         * - If post type is post/carousel -> media and caption text are required
         * - If post type is story -> only media is required
         */
        // if (!post.media || post.media.length <= 0 && post.type !== 'story') {
        //   this.$swal({
        //     type: 'warning',
        //     text: 'Post Media is missing in your draft, please check.'
        //   });
        //   return false;
        // }
        if ((!post.captionText || post.captionText.length <= 0) && post.type !== 'story') {
          this.$swal({
            type: 'warning',
            text: 'Post Caption is missing in your draft, please check.'
          });
          return false;
        }
      }
      return true;
    },
    async fetchInvitedCampaign(influencerID, status) {
      try {
        if (!influencerID) throw new Error('Your social media account is not connected.');
        const campaigns = await pairingAPIs.getInvitedCampaigns(influencerID, status);
        this.campaigns = Object.assign([], campaigns);
        // console.log('🚀 ~ file: CreateDraftPostV2.vue ~ line 634 ~ fetchInvitedCampaign ~ this.campaigns', this.campaigns)
      } catch (error) {
        const message = error.message ? error.message : 'Cannot get campaigns';
        this.$swal({
          type: 'error',
          text: message
        }).then((result) => {
          if (result.value) {
            this.$router.push('Profile');
          }
        });
      }
    },
    addPost(postType) {
      const post = Object.assign({}, postType)
      this.posts.push(post);
    },
    deletePost(postIndex) {
      this.posts.splice(postIndex, 1);
    },
    postTypeChanged(postIndex, postType) {
      if (this.posts[postIndex].type === postType.type) {
        return;
      }
      this.posts[postIndex] = Object.assign({}, this.posts[postIndex], postType)
      this.posts.splice();
    },
    textChanged(text, index) {
      this.posts[index].captionText = text;
    },
    vdoLinkChanged(text, index) {
      this.posts[index].vdoLink = text;
    },
    remarkChanged(text, index) {
      this.posts[index].remark = text;
    },
    mediaChanged(media, index) {
      this.posts[index].media = media;
    },
    viewMedia(media) {
      this.imageDialog = true
      this.previewMedia = ''
      this.previewMedia = media
      // if (media.file.type.indexOf('image') !== -1) {
      //   this.mediaType = 'image'
      //   this.previewMedia = media.preview.src;
      // } else {
      //   this.mediaType = 'vdo'
      //   setTimeout(() => {
      //     let video = document.getElementById('postVdo')
      //     let file = media.file
      //     let blobURL = URL.createObjectURL(file)
      //     video.src = blobURL
      //     if (file.type.indexOf('mp4') !== -1) {
      //       video.type = 'video/mp4'
      //     } else if (file.type.indexOf('quicktime') !== -1) {
      //       video.type = 'video/quicktime'
      //     }
      //     video.load()
      //   }, 700)
      // }
    },
    modalClickOutSide() {
      if (this.mediaType === 'vdo') {
        let vdoCtrl = document.getElementById('postVdo')
        vdoCtrl.pause()
        vdoCtrl.currentTime = 0
        vdoCtrl.src = ''
      }
    },
    paserImageUrl(url) {
      if (url) {
        var newUrl = url
          .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
          .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    showDetails(post) {
      this.postData = post
      this.postDetail = true;
    },
    checkOpenBillingDialog(currentInf) {
      if (!currentInf.fullName ||
      !currentInf.country ||
      !currentInf.bankName ||
      !currentInf.bankAccount ||
      !currentInf.billingEmail ||
      !currentInf.mailingAddress
      ) {
        this.$router.push({path: '/profile'})
      }
    },
    getInfluencerData() {
      // Retrieve user profile, add additional fields as needed
      userAPIs.getUser(this.currentUserID).then(async (response) => {
        this.influencerProfile.platform = this.activePlatform
        if (this.showActivePlatform) {
          this.influencerProfile.handle = this.showActivePlatform.handle
        } else {
          switch (this.activePlatform) {
            case 'tiktok':
              this.influencerProfile.handle = this.currentUser.tiktokHandle
              break;
            case 'youtube':
              this.influencerProfile.handle = this.currentUser.youtubeHandle
              break;
            case 'linkedin':
              this.influencerProfile.handle = this.currentUser.linkedinHandle
              break;
            case 'twitter':
              this.influencerProfile.handle = this.currentUser.twitterHandle
              break;
            default:
              this.influencerProfile.handle = this.currentUser.igHandle
              break;
          }
        }
        if (response.influencer) {
          this.currentInf = response.influencer
          let inf = response.influencer
          if (!inf.instagram && !inf.tiktok && !inf.youtube && !inf.linkedin && !inf.twitter &&
          !inf.reqIgHandle && !inf.reqTikTokHandle && !inf.reqYoutubeHandle) {
            this.$swal({
              text: 'Please Connect Platform',
              type: 'warning',
              allowOutsideClick: false
            }).then(result => {
              if (result.value) {
                this.$router.push({path: '/profile'})
              }
            })
          } else if (!this.showActivePlatform) {
            if (this.activePlatform === 'linkedin' && inf.linkedin) {
              this.influencerProfile.handle = inf.linkedin.linkedinHandle
            } else if (this.activePlatform === 'twitter' && inf.twitter) {
              this.influencerProfile.handle = inf.twitter.twitterHandle
            } else if (inf.reqIgHandle) {
              this.influencerProfile.handle = inf.reqIgHandle
            } else if (inf.reqTikTokHandle) {
              this.influencerProfile.handle = inf.reqTikTokHandle
            } else if (inf.reqYoutubeHandle) {
              this.influencerProfile.handle = inf.reqYoutubeHandle
            }
          }
          if (!this.influencerProfile) {
            this.$swal({ type: 'warning', text: 'Please Connect Platform' }).then(result => {
              if (result.value) {
                this.$router.push({path: '/profile'})
              }
            });
            return false;
          } else {
            if (!this.influencerProfile.handle) {
              this.$swal({ type: 'warning', text: 'Please Connect Platform' }).then(result => {
              if (result.value) {
                this.$router.push({path: '/profile'})
              }
            });
              return false;
            }
          }
        } else {
          this.$swal({
            text: 'Error Occured. Please login again!',
            type: 'warning',
            allowOutsideClick: false
          }).then(result => {
            if (result.value) {
              // Dispatch event from store
              this.$store.dispatch('LOG_OUT')
              this.$store.commit('REMOVE_ACTIVE_PLATFORM')

              // Redirect to home page
              this.$router.push({ name: 'Login' })
            }
          })
        }
        if (this.currentInf) {
          this.checkOpenBillingDialog(this.currentInf)
        }
        // if (response.influencer.tiktok) {
        //   this.influencerProfile.handle = response.influencer.tiktok.tiktokHandle
        //   this.influencerProfile.platform = 'tiktok'
        // } else {
        //   this.influencerProfile.handle = response.influencer.instagram.instagramHandle
        //   this.influencerProfile.platform = 'instagram'
        // }
      }).catch(error => {
        this.$swal({
          text: 'Your current session is expired. Please login again.',
          type: 'warning',
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            if (error.response.status === 403) {
              this.$store.dispatch('LOG_OUT')
              this.$router.push({ name: 'Login' })
            } else {
              this.$router.push({path: '/profile'})
            }
          }
        })
        console.log(error)
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// CreateDraftPostV2.vue?0c39483d